// extracted by mini-css-extract-plugin
export default {"reservationModal":"ReservationDetailModal_reservationModal__f2qDy","reservationModalMobile":"ReservationDetailModal_reservationModalMobile__GaHYw"};